import { t } from "@/i18n-js/instance";
import type { PaywallCheckoutPreview } from "@/react/types";

import type { CheckoutPreviewEntryProps } from "../../../components/PreviewEntry";
import type { ComponentLineProps } from "../../FirstPaymentPreview/types";
import { shouldExpandFirstPayment } from "../../FirstPaymentPreview/variants/helpers";
import { RawLines } from "../RawLines";
import {
  isOneInstallment,
  shouldExpandFuturePayments,
} from "../variants/helpers";

const showSubtotal = (preview: PaywallCheckoutPreview) => ({
  value: preview?.future_payments?.formatted_subtotal,
  hide: !shouldExpandFuturePayments(preview),
});

const oneInstallmentsStrategies = {
  trial_then_value: (preview: PaywallCheckoutPreview) => ({
    value: preview.first_payment.formatted_subtotal,
    hide: !shouldExpandFirstPayment(preview),
  }),
  trial_then_upfront_then_value: showSubtotal,
  upfront_then_trial_then_value: showSubtotal,
  upfront_then_value: showSubtotal,
  value: () => ({ hide: true }),
};

const buildOptions = (
  preview: PaywallCheckoutPreview,
): Partial<CheckoutPreviewEntryProps> => {
  if (isOneInstallment(preview)) {
    return oneInstallmentsStrategies[preview.preview_scenario](preview);
  }

  return { hide: !shouldExpandFuturePayments(preview) };
};

export const RegularPriceLine = ({
  preview,
}: Pick<ComponentLineProps, "preview">) => {
  const options = buildOptions(preview);
  return (
    <RawLines.RegularPriceLine
      preview={preview}
      options={{ label: t("subtotal"), ...options }}
    />
  );
};
